import { Provider } from '@angular/core';
import {
  provideSoftAppsModule,
  withSoftAppsModuleRoutes,
  withSoftAppsModuleTranslation,
} from '@softapps/core';
import { default as de } from './../i18n/de.json';
import { palettenkorrekturRoutes } from './palettenkorrektur.routes';
import { getModuleGroupByName } from '@softline/application';

export function providePalettenkorrektur(): Provider[] {
  return [
    provideSoftAppsModule(
      {
        name: 'palettenkorrektur',
        title: 'Paletten-Korrektur',
        icon: 'fa-regular fa-pallet-boxes',
        route: '/palettenkorrektur',
        permission: 'SOFTAPP.LAGER.PALETTENKORREKTUR',
        group: getModuleGroupByName('Lager'),
      },
      withSoftAppsModuleRoutes({
        app: palettenkorrekturRoutes,
      }),
      withSoftAppsModuleTranslation({
        de,
      })
    ),
  ];
}
